import { React, Component, Container, Route, _ } from "utils";
import { FairStore, Creators, EventStore, App } from "model";
import { Back, ActiveEvents, Loading, EventDetails } from "components";
import { Switch } from "react-router-dom";
import "./eventspage.less";

class EventsPage extends Component {
  static getStores() {
    return [FairStore, EventStore];
  }

  static calculateState() {
    let events = EventStore.getEvents();
    let background = EventStore.getBackground();
    let title = FairStore.getFairTitle(_("Events"));
    let loading = EventStore.isLoading();

    return {
      events,
      title,
      background,
      loading,
    };
  }

  componentDidMount() {
    Creators.loadEvents();
  }

  render() {
    let { title, events, background, loading } = this.state;

    App.setPageTitle(title);

    let style = {};

    if (background) {
      style.backgroundImage = App.url(background);
    }

    return (
      <div className="page index activity">
        <div className="menu">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <Back />
          </nav>
        </div>
        <div className="container">
          <div className="background">
            <div style={style} />
          </div>
          <div className="content">
            <div className="col-md-12">
              <Switch>
                <Route
                  exact={true}
                  path="/events/:eventId"
                  render={({ match }) => (
                    <div>
                      <EventDetails />
                    </div>
                  )}
                />

                <Route
                  path="/events"
                  render={() => (
                    <div>
                      <h1
                        style={{ marginBottom: "30px" }}
                        className="display-5"
                      >
                        {_("Events")}
                      </h1>
                      <Loading visible={loading} description={_("Loading")} />
                      <ActiveEvents data={events} />
                    </div>
                  )}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Container.create(EventsPage);



// WEBPACK FOOTER //
// ./src/modules/pages/eventspage.js